import { useState } from "react";
import { ReadQRCode } from "./ReadQRcode"

interface readQRCodeModalProps {
    isModal: boolean;
    setIsModal: (boolean: boolean) => void;
    cookieAccId: string;
    cookieRotaryCd: string;
}

/**
 * QRコード読込モーダルのコンポネント
 */
export function ReadQRCodeModal(props: readQRCodeModalProps) {

    const [isCameraActive, setIsCameraActive] = useState(true);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    return (
        <>
            <div className="overlay-box">
                <div className="modal-box">
                    <div className="modal-base">
                        <div className="mdl-wrap">
                            <div className="mdl-cont">
                                <dl className="mdl-dl">
                                    <div className="qr-box">

                                        {isCameraActive &&
                                            <ReadQRCode
                                                cookieAccId={props.cookieAccId}
                                                cookieRotaryCd={props.cookieRotaryCd}
                                                isCameraActive={isCameraActive}
                                                setIsCameraActive={setIsCameraActive}
                                                message={message}
                                                setMessage={setMessage}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                            />}

                                        {errorMessage !== "" ? (
                                            <div className="error">{errorMessage}</div>
                                        ) : !isCameraActive && (
                                            <div className="success">
                                                <i className="ic-success" />
                                                {message}
                                            </div>
                                        )}

                                    </div>
                                    <div className="btn-area">
                                        <div className="flex-center is-col">
                                            <button type="button"
                                                className="btn-main btnsz-l"
                                                onClick={() => props.setIsModal(!props.isModal)}
                                            >
                                                マイページへ
                                            </button>
                                        </div>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="overlay-bg" />
        </>
    )
}

